// extracted by mini-css-extract-plugin
export var table = "_uk-0";